import { render, staticRenderFns } from "./NewArrivals.vue?vue&type=template&id=348643be&scoped=true"
import script from "./NewArrivals.vue?vue&type=script&lang=ts"
export * from "./NewArrivals.vue?vue&type=script&lang=ts"
import style0 from "./NewArrivals.vue?vue&type=style&index=0&id=348643be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348643be",
  null
  
)

export default component.exports